import { render, staticRenderFns } from "./DialogSelectSupervisor.vue?vue&type=template&id=2034a8c6&"
import script from "./DialogSelectSupervisor.vue?vue&type=script&lang=js&"
export * from "./DialogSelectSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports